import React, { FC } from 'react';

import {
  AcAccordion,
  AcAccordionClampContent,
  AcAccordionHeader,
  AcAccordionItem
} from '@ac/mobile-components/dist/components/accordion';

import './Accordion.css';

interface ComponentProps {
  header: React.ReactNode;
  id: string;
  children: React.ReactNode;
}

const Accordion: FC<ComponentProps> = (props: ComponentProps) => {
  return (
    <AcAccordion className="accordion">
      <AcAccordionItem id={props.id}>
        <AcAccordionHeader>{props.header}</AcAccordionHeader>
        <AcAccordionClampContent>{props.children}</AcAccordionClampContent>
      </AcAccordionItem>
    </AcAccordion>
  );
};

export default Accordion;



// WEBPACK FOOTER //
// ./src/components/TaskManagement/TaskPreview/LinkedObject/shared/Accordion/Accordion.tsx